// src/wizard/productFilter.js

// 絞り込みに使わない質問（相談・現地調査の参考情報としてだけ保存する）
export const NON_FILTER_KEYS = ["buildingType"];

export const getRelevantKeys = (selections) => {
  return Object.entries(selections)
    .filter(([k, v]) => v !== "こだわらない" && !NON_FILTER_KEYS.includes(k))
    .map(([k]) => k);
};

export const calcMatches = ({ products, selections, featureMatches }) => {
  const relevantKeys = getRelevantKeys(selections);

  const exactMatches = products.filter((product) => {
    return relevantKeys.every((k) =>
      featureMatches(product.features?.[k], selections[k], k, product)
    );
  });

  const alternativeMatches = products
    .map((product) => {
      const matchCount = relevantKeys.reduce((count, k) => {
        return featureMatches(product.features?.[k], selections[k], k, product) ? count + 1 : count;
      }, 0);
      return { ...product, matchCount };
    })
    .filter((product) => product.matchCount >= relevantKeys.length - 2)
    .sort((a, b) => b.matchCount - a.matchCount);

  return { exactMatches, alternativeMatches };
};
